/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { withDynamicImport } from '@thd-nucleus/app-render';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
import { useHydratedProps, withLayout, withLayoutAccordion, mergeProductClientOnlyProduct }
from '@thd-olt-component-react/fusion-utils';

import { SuperSkuMiddleware as SuperSkuMiddleware_MiddlewareSlot
  ,
  RulesMiddleware as RulesMiddleware_MiddlewareSlot
  , withMagicApronTNT } from '@thd-olt-component-middleware/pip';

import { ProductOverviewAccordionTitle as ProductOverviewAccordionTitleG7Index0K0Header }
from '@thd-olt-component-react/product-overview';

import { SpecificationsAccordionTitle as SpecificationsAccordionTitleG7Index1K0Header }
from '@thd-olt-component-react/specifications';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleG7Index2K0Header }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleG7Index3K0Header }
from '@thd-olt-component-react/ratings-and-reviews';

const lazySlots = {};
const getPlaceholder = ({ skip }) => {
  if (skip) return null;
  return (
    <Skeleton>
      <SkeletonBlock />
      <SkeletonLine />
    </Skeleton>
  );
};

const SlotF3Placeholder0 = null;

const SlotF3Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "augmentedreality" */
    '@thd-olt-component-react/augmented-reality');
};

export const SlotF3Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/augmented-reality'))
      .AugmentedReality;
  },
  client: SlotF3Index0Client,
  placeholder: SlotF3Placeholder0 || getPlaceholder({ skip: true }),
  name: 'AugmentedReality',
});

lazySlots.LazyAugmentedRealityF3 = withLayout(

  [

    SlotF3Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotF3Index0Client,
      placeholder: SlotF3Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF6Placeholder0 = null;

const SlotF6Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "disclaimermessage" */
    '@thd-olt-component-react/disclaimer-message');
};

export const SlotF6Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/disclaimer-message'))
      .DisclaimerMessage;
  },
  client: SlotF6Index0Client,
  placeholder: SlotF6Placeholder0 || getPlaceholder({ skip: true }),
  name: 'DisclaimerMessage',
});

lazySlots.LazyDisclaimerMessageF6 = withLayout(

  [

    SlotF6Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotF6Index0Client,
      placeholder: SlotF6Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF7Placeholder0 = null;

const SlotF7Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "consumercardmessaging" */
    '@thd-olt-component-react/consumer-card-messaging');
};

export const SlotF7Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/consumer-card-messaging'))
      .ConsumerCardMessaging;
  },
  client: SlotF7Index0Client,
  placeholder: SlotF7Placeholder0 || getPlaceholder({ skip: true }),
  name: 'ConsumerCardMessaging',
});

lazySlots.LazyConsumerCardMessagingF7 = withLayout(

  [

    SlotF7Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotF7Index0Client,
      placeholder: SlotF7Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF9Placeholder0 = null;

const SlotF9Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "globalcustomconfigurator" */
    '@thd-olt-component-react/global-custom-configurator');
};

export const SlotF9Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/global-custom-configurator'))
      .GlobalCustomConfigurator;
  },
  client: SlotF9Index0Client,
  placeholder: SlotF9Placeholder0 || getPlaceholder({ skip: true }),
  name: 'GlobalCustomConfigurator',
});

lazySlots.LazyGlobalCustomConfiguratorF9 = withLayout(

  [

    SlotF9Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotF9Index0Client,
      placeholder: SlotF9Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF11Placeholder0 = null;

const SlotF11Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "aislebay" */
    '@thd-olt-component-react/aisle-bay');
};

export const SlotF11Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/aisle-bay'))
      .AisleBay;
  },
  client: SlotF11Index0Client,
  placeholder: SlotF11Placeholder0 || getPlaceholder({ skip: true }),
  name: 'AisleBay',
});

lazySlots.LazyAisleBayF11 = withLayout(

  [

    SlotF11Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotF11Index0Client,
      placeholder: SlotF11Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF12Placeholder0 = null;

const SlotF12Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "supersku" */
    '@thd-olt-component-react/super-sku');
};

export const SlotF12Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/super-sku'))
      .SuperSku;
  },
  client: SlotF12Index0Client,
  placeholder: SlotF12Placeholder0 || getPlaceholder({ skip: true }),
  name: 'SuperSku',
});

let SuperSkuMiddleware_MiddlewareSlot_F12 = SuperSkuMiddleware_MiddlewareSlot;

lazySlots.LazySuperSkuF12 = withLayout(

  [

    SlotF12Index0Load,

  ],

  SuperSkuMiddleware_MiddlewareSlot_F12
  ,

  [

    {
      waitForComponent: SlotF12Index0Client,
      placeholder: SlotF12Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF14Placeholder0 = null;

const SlotF14Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "ordersample" */
    '@thd-olt-component-react/order-sample');
};

export const SlotF14Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/order-sample'))
      .OrderSample;
  },
  client: SlotF14Index0Client,
  placeholder: SlotF14Placeholder0 || getPlaceholder({ skip: true }),
  name: 'OrderSample',
});

lazySlots.LazyOrderSampleF14 = withLayout(

  [

    SlotF14Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotF14Index0Client,
      placeholder: SlotF14Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF16Placeholder0 = null;

const SlotF16Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "returnsmessaging" */
    '@thd-olt-component-react/returns-messaging');
};

export const SlotF16Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/returns-messaging'))
      .ReturnsMessaging;
  },
  client: SlotF16Index0Client,
  placeholder: SlotF16Placeholder0 || getPlaceholder({ skip: true }),
  name: 'ReturnsMessaging',
});

lazySlots.LazyReturnsMessagingF16 = withLayout(

  [

    SlotF16Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotF16Index0Client,
      placeholder: SlotF16Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotG6Placeholder0 = null;

const SlotG6Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "botprompt" */
    '@thd-olt-component-react/magic-apron');
};

export const SlotG6Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
      .BotPrompt;
  },
  client: SlotG6Index0Client,
  placeholder: SlotG6Placeholder0 || getPlaceholder({ skip: true }),
  name: 'BotPrompt',
});

let RulesMiddleware_MiddlewareSlot_G6 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_G6 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_G6, { render: { name: 'fs-prop:magic-apron-qa-bot-render-placement', value: 'above-accordion' } });

lazySlots.LazyBotPromptG6 = withLayout(

  [

    SlotG6Index0Load,

  ],

  RulesMiddleware_MiddlewareSlot_G6
  ,

  [

    {
      waitForComponent: SlotG6Index0Client,
      placeholder: SlotG6Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotG7Placeholder0K0 = null;

const SlotG7Index0ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/product-overview');
};

export const SlotG7Index0LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
      .ProductOverviewAccordionBody;
  },
  client: SlotG7Index0ClientK0,
  placeholder: SlotG7Placeholder0K0 || getPlaceholder({ skip: true }),
  name: 'ProductOverviewAccordionBody',
});

lazySlots.LazyProductOverviewAccordionBodyG7 = withLayout(
  SlotG7Index0LoadK0,

  null
  ,
  {
    waitForComponent: SlotG7Index0ClientK0,
    placeholder: SlotG7Placeholder0K0 || getPlaceholder({ skip: true })
  }
);

const SlotG7Placeholder1K0 = null;

const SlotG7Index1ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/specifications');
};

export const SlotG7Index1LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
      .SpecificationsAccordionBody;
  },
  client: SlotG7Index1ClientK0,
  placeholder: SlotG7Placeholder1K0 || getPlaceholder({ skip: true }),
  name: 'SpecificationsAccordionBody',
});

lazySlots.LazySpecificationsAccordionBodyG7 = withLayout(
  SlotG7Index1LoadK0,

  null
  ,
  {
    waitForComponent: SlotG7Index1ClientK0,
    placeholder: SlotG7Placeholder1K0 || getPlaceholder({ skip: true })
  }
);

const SlotG7Placeholder2K0 = null;

const SlotG7Index2ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/questions-and-answers');
};

export const SlotG7Index2LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
      .QuestionsAndAnswersAccordionBody;
  },
  client: SlotG7Index2ClientK0,
  placeholder: SlotG7Placeholder2K0 || getPlaceholder({ skip: true }),
  name: 'QuestionsAndAnswersAccordionBody',
});

lazySlots.LazyQuestionsAndAnswersAccordionBodyG7 = withLayout(
  SlotG7Index2LoadK0,

  null
  ,
  {
    waitForComponent: SlotG7Index2ClientK0,
    placeholder: SlotG7Placeholder2K0 || getPlaceholder({ skip: true })
  }
);

const SlotG7Placeholder3K0 = null;

const SlotG7Index3ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/ratings-and-reviews');
};

export const SlotG7Index3LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
      .RatingsAndReviewsAccordionBody;
  },
  client: SlotG7Index3ClientK0,
  placeholder: SlotG7Placeholder3K0 || getPlaceholder({ skip: true }),
  name: 'RatingsAndReviewsAccordionBody',
});

lazySlots.LazyRatingsAndReviewsAccordionBodyG7 = withLayout(
  SlotG7Index3LoadK0,

  null
  ,
  {
    waitForComponent: SlotG7Index3ClientK0,
    placeholder: SlotG7Placeholder3K0 || getPlaceholder({ skip: true })
  }
);

const LazyG7Accordion = withLayoutAccordion([
  [

    [

      withLayout(
        ProductOverviewAccordionTitleG7Index0K0Header,

      ),

    ],

    [

      withLayout(
        SpecificationsAccordionTitleG7Index1K0Header,

      ),

    ],

    [

      withLayout(
        QuestionsAndAnswersAccordionTitleG7Index2K0Header,

      ),

    ],

    [

      withLayout(
        RatingsAndReviewsAccordionTitleG7Index3K0Header,

      ),

    ],

  ],
  [

    [

      lazySlots.LazyProductOverviewAccordionBodyG7,

    ],

    [

      lazySlots.LazySpecificationsAccordionBodyG7,

    ],

    [

      lazySlots.LazyQuestionsAndAnswersAccordionBodyG7,

    ],

    [

      lazySlots.LazyRatingsAndReviewsAccordionBodyG7,

    ],

  ]
],

null
);

const SlotG8Placeholder0 = null;

const SlotG8Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "botprompt" */
    '@thd-olt-component-react/magic-apron');
};

export const SlotG8Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
      .BotPrompt;
  },
  client: SlotG8Index0Client,
  placeholder: SlotG8Placeholder0 || getPlaceholder({ skip: true }),
  name: 'BotPrompt',
});

let RulesMiddleware_MiddlewareSlot_G8 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_G8 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_G8, { render: { name: 'fs-prop:magic-apron-qa-bot-render-placement', value: 'default', default: true } });

lazySlots.LazyBotPromptG8 = withLayout(

  [

    SlotG8Index0Load,

  ],

  RulesMiddleware_MiddlewareSlot_G8
  ,

  [

    {
      waitForComponent: SlotG8Index0Client,
      placeholder: SlotG8Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

// to be generated by ejs based on config
export const DynamicImporter = (props) => {
  const { storeId, storeZip } = useStore();
  const slot = props.config.slots[props.slot];
  const components = slot.isAccordion
    ? slot.components.flat().map((sc) => sc.components).flat()
    : slot.components.flat();

  // todo use merge option?
  const hydratedProps = useHydratedProps(components, { itemId: props.itemId });
  components.forEach((com, index) => {
    // eslint-disable-next-line no-param-reassign
    com.props = hydratedProps[index];
  });

  const merge = mergeProductClientOnlyProduct;

  // use this for debugging, attache to queryProvider prop

  // const queryOptions = ({ options, queryName }) => {
  //   return {
  //     ...options,
  //     fetchPolicy: 'cache-only'
  //   };
  // };

  if (props.slot === 'slotF3') {

    return (
      <lazySlots.LazyAugmentedRealityF3
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotF3"
        fusionComponentName="@thd-olt-component-react/augmented-reality"
        version="7.5.1"
      />
    );

  }

  if (props.slot === 'slotF6') {

    return (
      <lazySlots.LazyDisclaimerMessageF6
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotF6"
        fusionComponentName="@thd-olt-component-react/disclaimer-message"
        version="4.2.1"
      />
    );

  }

  if (props.slot === 'slotF7') {

    return (
      <lazySlots.LazyConsumerCardMessagingF7
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotF7"
        fusionComponentName="@thd-olt-component-react/consumer-card-messaging"
        version="8.20.2"
      />
    );

  }

  if (props.slot === 'slotF9') {

    return (
      <lazySlots.LazyGlobalCustomConfiguratorF9
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotF9"
        fusionComponentName="@thd-olt-component-react/global-custom-configurator"
        version="2.5.1"
      />
    );

  }

  if (props.slot === 'slotF11') {

    return (
      <lazySlots.LazyAisleBayF11
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotF11"
        fusionComponentName="@thd-olt-component-react/aisle-bay"
        version="7.11.1"
      />
    );

  }

  if (props.slot === 'slotF12') {

    return (
      <lazySlots.LazySuperSkuF12
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotF12"
        fusionComponentName="@thd-olt-component-react/super-sku"
        version="13.29.0"
      />
    );

  }

  if (props.slot === 'slotF14') {

    return (
      <lazySlots.LazyOrderSampleF14
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotF14"
        fusionComponentName="@thd-olt-component-react/order-sample"
        version="5.15.2"
      />
    );

  }

  if (props.slot === 'slotF16') {

    return (
      <lazySlots.LazyReturnsMessagingF16
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotF16"
        fusionComponentName="@thd-olt-component-react/returns-messaging"
        version="1.13.0"
      />
    );

  }

  if (props.slot === 'slotG6') {

    return (
      <lazySlots.LazyBotPromptG6
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotG6"
        fusionComponentName="@thd-olt-component-react/magic-apron"
        version="6.9.9"
      />
    );

  }

  if (props.slot === 'slotG7') {

    return (
      <LazyG7Accordion
        {...props}
        config={props.config}
        fusionSlotName="slotG7"
        fusionComponentName="accordion"
        fusionClassName={slot.fusionClassName}
        isDynamic
        // commenting inner query provider since withDynamicImport already wraps AccordionBody with inner query provider
        // queryProvider={{
        //   inherit: 'page',
        //   merge,
        //   queryOptions,
        //   cache key for all accordions must be the same
        //   otherwise a race condition will occur generating duplicate requests
        //   cacheKey: 'page',
        //   defaultVariables: props?.qctx?.defaultVariables?.current || { storeId, zipCode: storeZip }
        // }}
      />
    );

  }

  if (props.slot === 'slotG8') {

    return (
      <lazySlots.LazyBotPromptG8
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotG8"
        fusionComponentName="@thd-olt-component-react/magic-apron"
        version="6.9.9"
      />
    );

  }

  return null;
};

DynamicImporter.propTypes = {
  config: PropTypes.shape({
    slots: PropTypes.shape({})
  }).isRequired,
  slot: PropTypes.string.isRequired,
};
